import { articleDeleteSuccess } from './article-delete-success/index.tsx';
import {
	createCategory,
	handleFormInputChange,
	resetCreatedCategory,
} from './create-category/index.tsx';
import { deleteCategorySuccess } from './delete-category-success/index.tsx';
import { publishSuccess } from './draft-article-publish-success/index.tsx';
import { savedSuccess } from './draft-article-saved-success/index.tsx';
import { fetchCategories } from './fetch-categories/index.tsx';
import { fetchCreateArticlePermission } from './fetch-create-article-permissions/index.tsx';
import { fetchDraftAndNavigateToEditor } from './fetch-draft-and-navigate-to-editor/index.tsx';
import { fetchLinkedSpaces } from './fetch-linked-spaces/index.tsx';
import { fetchSuggestedTopics } from './fetch-suggested-topics/index.tsx';
import { fetchUserCapabilities } from './fetch-user-capabilities/index.tsx';
import { navigateCreateDraftRoute } from './navigate-create-draft-route/index.tsx';
import { setRedirectionData, resetRedirectionData } from './redirection-data/index.tsx';
import { removeCommonFlag } from './remove-common-flag/index.tsx';
import { reorderCategories } from './reorder-categories/index.tsx';
import { resetDraftArticleData } from './reset-draft-article-data/index.tsx';
import { setPagination } from './set-pagination/index.tsx';
import { updateCategorySuccess } from './update-category-success/index.tsx';
import { fetchConnectionStatus } from './fetch-connection-status/index.tsx';
import { setAuthStatus } from './set-auth-status/index.tsx';
import { setIsKbFeedbackBannerDismissed } from './set-is-kb-feedback-dismissed/index.tsx';

export const actions = {
	setRedirectionData,
	resetRedirectionData,
	publishSuccess,
	savedSuccess,
	fetchDraftAndNavigateToEditor,
	navigateCreateDraftRoute,
	fetchCreateArticlePermission,
	fetchLinkedSpaces,
	resetDraftArticleData,
	articleDeleteSuccess,
	fetchUserCapabilities,
	fetchCategories,
	reorderCategories,
	createCategory,
	handleFormInputChange,
	resetCreatedCategory,
	updateCategorySuccess,
	deleteCategorySuccess,
	removeCommonFlag,
	fetchSuggestedTopics,
	setPagination,
	fetchConnectionStatus,
	setAuthStatus,
	setIsKbFeedbackBannerDismissed,
} as const;

export type Actions = typeof actions;
